import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Store({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.66675 4.66667C2.66675 4.29848 2.96522 4 3.33341 4H20.6667C20.8436 4 21.0131 4.07024 21.1382 4.19526C21.2632 4.32029 21.3334 4.48986 21.3334 4.66667V8.66667C21.3334 9.14705 21.2251 9.5964 21.0319 10C20.8334 10.4147 20.5454 10.7812 20.1933 11.0833C20.1309 11.1369 20.0664 11.1885 20.0001 11.238C19.3554 11.7187 18.534 12 17.6667 12C16.4785 12 15.3763 11.4719 14.6968 10.6263C14.0908 11.4589 13.1086 12 12.0001 12C10.8915 12 9.90936 11.4589 9.30333 10.6263C8.62389 11.4719 7.52166 12 6.33341 12C5.46617 12 4.64475 11.7187 4.00008 11.238C3.5598 10.9097 3.20196 10.4883 2.96826 10C2.7751 9.5964 2.66675 9.14705 2.66675 8.66667V4.66667ZM4.00008 8.66667C4.00008 9.69959 4.96876 10.6667 6.33341 10.6667C7.69807 10.6667 8.66675 9.69959 8.66675 8.66667H10.0001C10.0001 9.77124 10.8955 10.6667 12.0001 10.6667C13.1047 10.6667 14.0001 9.77124 14.0001 8.66667H15.3334C15.3334 9.69959 16.3021 10.6667 17.6667 10.6667C19.0314 10.6667 20.0001 9.69959 20.0001 8.66667V5.33333H4.00008V8.66667Z"
        fill={iconColor}
      />
      <Path
        d="M20.0001 12.7884C20.493 12.5465 20.9461 12.2289 21.3334 11.8455V20.6667C21.3334 21.0349 21.0349 21.3333 20.6667 21.3333H14.0001C13.6319 21.3333 13.3334 21.0349 13.3334 20.6667V16H10.6667V20.6667C10.6667 21.0349 10.3683 21.3333 10.0001 21.3333H3.33341C2.96522 21.3333 2.66675 21.0349 2.66675 20.6667V11.8455C3.05411 12.2289 3.50713 12.5465 4.00008 12.7884V20H9.33342V15.3333C9.33342 14.9651 9.63189 14.6667 10.0001 14.6667H14.0001C14.3683 14.6667 14.6667 14.9651 14.6667 15.3333V20H20.0001V12.7884Z"
        fill={iconColor}
      />
    </Svg>
  );
}
